export default __webpack_public_path__ + "static/media/chess-brilliancy.d3aaba86.webp";